module.exports = __webpack_public_path__ + "img/logs.5608f241.png";